module.exports = __webpack_public_path__ + "img/main.5f12b252.png";